module.exports = __webpack_public_path__ + "img/not-found-game.3f875591.png";